export default __webpack_public_path__ + "static/butik_img4-60f05209ffb89e489966b03b8a3245fd.png";